import CryptoJS from "crypto-js";

function ApiEncrypt(apiKey, secretKey) {
  // Encrypt
  var ciphertext = CryptoJS.AES.encrypt(apiKey, secretKey).toString();
  return ciphertext;
}

export default ApiEncrypt;
